import { TasksResponseType } from '@/api/backend/types';
import { formatIsoDate } from '@/lib/utils';
import { Badge } from '@opaz/ui-components';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

import { useTranslation } from 'react-i18next';

type TaskStatusBadgeProps = {
  endTime: TasksResponseType['endTime'];
  dueDate: TasksResponseType['dueDate'];
};

export const TaskStatusBadge = ({ endTime, dueDate }: TaskStatusBadgeProps) => {
  const { t, i18n } = useTranslation();

  if (endTime) {
    return (
      <Badge className="whitespace-nowrap" type="positive" filled>
        {t('tasks.status.completed')}
      </Badge>
    );
  }

  if (!dueDate) {
    return '-';
  }

  if (dayjs(dueDate).isBefore(dayjs())) {
    return (
      <Badge className="whitespace-nowrap" type="negative" filled>
        {t('tasks.status.overdue', {
          time: dayjs(dueDate).from(dayjs(), true),
        })}
      </Badge>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <div>
        <Badge className="whitespace-nowrap">
          {t('tasks.status.todo', {
            time: dayjs().to(dueDate, true),
          })}
        </Badge>
      </div>

      <span>{formatIsoDate(dueDate, i18n.language)}</span>
    </div>
  );
};
